












































import { defineComponent } from '@vue/composition-api'

import { NgReason } from '@/types/questionnaire'

import { AppToggleButton } from '@/components/atoms'
import { QuestionnaireAnswerEntity } from '../../../../api/@types'

type Props = {
  questionnaireAnswer: QuestionnaireAnswerEntity
}

export default defineComponent({
  name: 'QuestionnaireAnswerActions',
  components: { AppToggleButton },
  props: {
    questionnaireAnswer: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props: Props, context) {
    const toggleError = (newNgReason: NgReason) => {
      let ngReason: null | NgReason = newNgReason
      if (props.questionnaireAnswer.ngReason === newNgReason) {
        ngReason = null
      }
      const newQuestionnaireAnswer = {
        ...props.questionnaireAnswer,
        ngReason,
      }
      context.emit('update:questionnaireAnswer', newQuestionnaireAnswer)
    }

    return {
      toggleError,
      NgReason,
    }
  },
})
